import React from 'react'

import './signs-item.scss'
import { navigate } from 'gatsby'
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"

const SignsItem = ({ infoSing}) => {
    // var news_info=props.dataProp

    const userInfoEncrypt= encryptUserInfo()
    return (
        <div onClick={()=>{
            pushDataLayerEvent({
                event: "Interacciones - Horóscopo",
                category: "magazin",
                action: "click",
                label: "Ver frase de la semana",
                sub_category:'Horóscopo',
                zodiac_sign:infoSing.titulo,
                location: window.location.href,
                user_data: userInfoEncrypt.user_data? userInfoEncrypt.user_data: '',
                log_status: userInfoEncrypt.log_status,
            })
            navigate(infoSing.slug)}} className="f-signsItem">
            <div className="f-signsItem-header">
                <div className="f-signsItem-icon">
                        <span className={infoSing.iconoDelSigno}></span>
                </div>
                <h2>{infoSing.titulo}</h2>
            </div>
            
            <span className="f-signsItem-date">{infoSing.fechaDelSigno}</span>
            <p>{infoSing.descripcionDelSigno.descripcionDelSigno}</p>
            <div className="f-signsItem-hover">
                <p>Ver frase<br /> de la semana</p>
            </div>
        </div>
    )
}

export default SignsItem;
